import React from 'react';
import { Provider } from 'react-redux';
import store from '../../app/store';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'reduxjs-toolkit-persist/integration/react';

interface Props {
    children?: React.ReactNode;
}

export const ReduxStoreProvider = ({ children }: Props) => {
    const persistor = persistStore(store);
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                {children}
            </PersistGate>
        </Provider>
    );
};
